export default [
  {
    path: '/user',
    name: 'user',
    component: () => import('@/views/menu/user/user.vue'),
    meta: {
      pageTitle: 'کاربران',
      action: 'show',
      resource: 'UserManager',
    },
  },
  {
    path: '/user/details/:id',
    name: 'userDetail',
    component: () => import('@/views/menu/user/userdetails.vue'),
    meta: {
      pageTitle: 'ویرایش کاربر',
      action: 'show',
      resource: 'UserInfoView',
    },
  },
  {
    path: '/userrole',
    name: 'userrole',
    component: () => import('@/views/menu/user/userrole.vue'),
    meta: {
      pageTitle: 'نقش ها',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details',
    name: 'adduserrole',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'ایجاد نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userrole/details/:id',
    name: 'updateuserrole',
    component: () => import('@/views/menu/user/userroledetails.vue'),
    meta: {
      pageTitle: 'ویرایش نقش',
      action: 'show',
      resource: 'UserRoleManager',
    },
  },
  {
    path: '/userspecialdiet',
    name: 'userspecialdiet',
    component: () => import('@/views/menu/user/userspecialdiet.vue'),
    meta: {
      pageTitle: 'رژیم های زیروفیت',
      action: 'show',
      resource: 'SpecialDietManager',
    },
  },
  {
    path: '/userspecialdiet/details',
    name: 'adduserspecialdiet',
    component: () => import('@/views/menu/user/userspecialdietdetails.vue'),
    meta: {
      pageTitle: 'ایجاد رژیم زیروفیت',
      action: 'show',
      resource: 'SpecialDietManager',
    },
  },
  {
    path: '/userspecialdiet/details/:id',
    name: 'updateuserspecialdiet',
    component: () => import('@/views/menu/user/userspecialdietdetails.vue'),
    meta: {
      pageTitle: 'ویرایش رژیم زیروفیت',
      action: 'show',
      resource: 'SpecialDietManager',
    },
  },



  {
    path: '/userquestionanswer/:id',
    name: 'userquestionanswer',
    component: () => import('@/views/menu/user/UserQuestionAnswer.vue'),
    meta: {
      pageTitle: 'ویرایش رژیم زیروفیت',
      action: 'show',
      resource: 'SpecialDietManager',
    },
  },


  {
    path: '/users/SuccessfulPeopleManager/',
    name: 'SuccessfulPeopleManager',
    component: () => import('@/views/miscellaneous/ComingSoon.vue'),
    meta: {
      pageTitle: 'افراد موفق',
      action: 'show',
      resource: 'SuccessfulPeopleManager',
    },
  },

  {
    path: '/nutritionists',
    name: 'nutritionists',
    component: () => import('@/views/menu/user/nutritionist/nutritionists.vue'),
    meta: {
      pageTitle: 'کارشناسان تغذیه',
      action: 'show',
      resource: 'NutritionistManager',
    },
  },
]
